import * as React from 'react';
import styled from 'styled-components';
import { FieldTextStateless as AkFieldText } from '@atlaskit/field-text';
import { BindProps } from 'modules/form/BindFieldInput';

// PUR-17957
// Atlaskit FieldText has a typo in its style (missing an '&' before [Disabled] section).
// That section is necessary for Safari's correct rendering when the input is disabled.
// Otherwise the text disappears. This is a workaround to fix that.
const FixStyleBug = styled.span`
  input[disabled] {
    -webkit-text-fill-color: unset;
    -webkit-opacity: 1;
  }
`;

export default ({
  field,
  akRef,
  onValidation,
  setIsFieldEmpty,
  ...props
}: BindProps<typeof AkFieldText>) => {
  const invalidMessage = field.invalidErrorMessage
    ? field.invalidErrorMessage
    : field.validity.error.text;

  const isInvalid = field.invalidErrorMessage
    ? !!field.invalidErrorMessage
    : !field.validity.isValid;

  const handleChange = ({ target: { value } }) => {
    field.edit(value);
    if (onValidation) {
      onValidation(value);
    }
    if (setIsFieldEmpty) {
      setIsFieldEmpty(!value);
    }
  };

  return field ? (
    <FixStyleBug>
      <AkFieldText
        {...props}
        ref={akRef}
        isInvalid={isInvalid}
        invalidMessage={invalidMessage}
        validationMessage={invalidMessage}
        validationState={isInvalid ? 'error' : 'success'}
        value={field.value}
        onChange={handleChange}
        // Atlaskit <Field> overrides onBlur of its child component.
        // I.e. you can't set onBlur on FieldText. So make sure our wrapper overrules it here.
        onBlur={field.onBlur}
      />
    </FixStyleBug>
  ) : null;
};
